<ng-container *ngrxLet="modalData.component$ as component">
	<div *nzModalTitle>
		<span class="text-base md:text-lg lg:text-lg">
			{{ modalData.title }}
		</span>
		@if (modalData.subTitle) {
			@if (isArray(modalData.subTitle)) {
				<fms-chip>
					@for (
						elem of modalData.subTitle;
						track elem;
						let last = $last
					) {
						{{ elem }}
						@if (!last) {
							<nz-divider nzType="vertical" />
						}
					}
				</fms-chip>
			} @else {
				<fms-chip>{{ modalData.subTitle }}</fms-chip>
			}
		}
	</div>
	<div class="p-4">
		<div>
			@if (component?.aboveFoldContent) {
				<p markdown class="text-lg">
					{{ component.aboveFoldContent }}
				</p>
			}
			@if (showBelowFold) {
				<p markdown class="text-lg">
					{{ component?.belowFoldContent }}
				</p>
			}
		</div>
	</div>
	<div *nzModalFooter class="h-12">
		<fms-toggle-favorite-button
			class="float-left"
			mode="button"
			[componentId]="component.id"
			[actionId]="component?.favoriteAction?.id"
		/>
		<fms-button class="float-right" (click)="closeModal()">
			<span class="mr-2">
				<svg
					class="h-6 opacity-50"
					xmlns="http://www.w3.org/2000/svg"
					fill="none"
					viewBox="0 0 24 24"
					stroke="currentColor"
				>
					<path
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="2"
						d="M5 13l4 4L19 7"
					/>
				</svg>
			</span>
			Luk
		</fms-button>
	</div>
</ng-container>
